exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".iwd-carousel{width:100%}.iwd-carousel .carousel .slider-wrapper{height:50vh}.iwd-carousel .carousel .slide{text-align:unset;background:none !important;border:unset !important}.iwd-carousel .carousel .slide img{width:unset;vertical-align:unset}.iwd-carousel-card-view-container{height:100%;display:flex;justify-content:space-between;column-gap:40px}@media only screen and (max-width: 450px){.iwd-carousel-card-view-container{flex-direction:column;flex-wrap:nowrap;column-gap:unset}}", ""]);

// exports
